"use client";

import { c as _c } from "react/compiler-runtime";
import * as Headless from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/16/solid";
import clsx from "clsx";
import { Fragment } from "react";
export const listboxButtonClasses = ["group relative block w-full",
// Hide default focus styles
"focus:outline-hidden",
// Focus ring
"after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-transparent after:ring-inset data-focus:after:ring-2 data-focus:after:ring-blue-500",
// Disabled state
"data-disabled:opacity-50 data-disabled:before:bg-zinc-950/5 data-disabled:before:shadow-none"];
export function Listbox(t0) {
  const $ = _c(31);
  let ariaLabel;
  let autoFocus;
  let className;
  let options;
  let placeholder;
  let props;
  let selectedClassName;
  if ($[0] !== t0) {
    ({
      className,
      placeholder,
      autoFocus,
      "aria-label": ariaLabel,
      selectedClassName,
      children: options,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = autoFocus;
    $[3] = className;
    $[4] = options;
    $[5] = placeholder;
    $[6] = props;
    $[7] = selectedClassName;
  } else {
    ariaLabel = $[1];
    autoFocus = $[2];
    className = $[3];
    options = $[4];
    placeholder = $[5];
    props = $[6];
    selectedClassName = $[7];
  }
  let t1;
  if ($[8] !== className) {
    t1 = clsx([className, listboxButtonClasses]);
    $[8] = className;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== placeholder) {
    t2 = placeholder && <span className="text-muted-foreground block truncate">{placeholder}</span>;
    $[10] = placeholder;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== selectedClassName) {
    t3 = clsx(["relative block w-full appearance-none py-[calc(--spacing(2.5)-1px)] sm:py-[calc(--spacing(1.5)-1px)]", "min-h-11 sm:min-h-9", "pr-[calc(--spacing(7)-1px)] pl-[calc(--spacing(3.5)-1px)] sm:pl-[calc(--spacing(3)-1px)]", "placeholder:text-muted-foreground text-left text-base/6 sm:text-sm/6 forced-colors:text-[CanvasText]", "border-border border", "group-data-hover:bg-border/35 group-data-focus:bg-border/50", "group-data-invalid:border-red-500 group-data-hover:group-data-invalid:border-red-500 dark:group-data-invalid:border-red-600 dark:data-hover:group-data-invalid:border-red-600", "group-data-disabled:border-zinc-950/20 group-data-disabled:opacity-100 dark:group-data-disabled:border-white/15 dark:group-data-disabled:bg-white/[2.5%] dark:group-data-disabled:data-hover:border-white/15", selectedClassName]);
    $[12] = selectedClassName;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== options || $[15] !== t2 || $[16] !== t3) {
    t4 = <Headless.ListboxSelectedOption as="span" data-slot="selected-option" options={options} placeholder={t2} className={t3} />;
    $[14] = options;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"><ChevronUpDownIcon className="text-border dark:text-muted-foreground/25 group-data-hover:text-muted-foreground/75 group-data-[open]:text-muted-foreground/75 size-3.5" /></span>;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== ariaLabel || $[20] !== autoFocus || $[21] !== t1 || $[22] !== t4) {
    t6 = <Headless.ListboxButton autoFocus={autoFocus} data-slot="control" aria-label={ariaLabel} className={t1}>{t4}{t5}</Headless.ListboxButton>;
    $[19] = ariaLabel;
    $[20] = autoFocus;
    $[21] = t1;
    $[22] = t4;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = clsx("z-50", "[--anchor-offset:-1.625rem] [--anchor-padding:--spacing(4)] sm:[--anchor-offset:-1.375rem]", "isolate w-max min-w-[calc(var(--button-width)+1.75rem)] scroll-py-1 rounded-xl p-1 select-none", "outline outline-transparent focus:outline-hidden", "overflow-y-scroll overscroll-contain", "bg-background/75 backdrop-blur-xl", "ring-border shadow-lg ring-1 dark:ring-inset", "transition-opacity duration-100 ease-in data-closed:data-leave:opacity-0 data-transition:pointer-events-none");
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== options) {
    t8 = <Headless.ListboxOptions transition={true} anchor="selection start" className={t7}>{options}</Headless.ListboxOptions>;
    $[25] = options;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== props || $[28] !== t6 || $[29] !== t8) {
    t9 = <Headless.Listbox {...props} multiple={false}>{t6}{t8}</Headless.Listbox>;
    $[27] = props;
    $[28] = t6;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
}
export function ListboxOption(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("flex min-w-0 items-center", "*:data-[slot=icon]:size-5 *:data-[slot=icon]:shrink-0 sm:*:data-[slot=icon]:size-4", "*:data-[slot=icon]:text-muted-foreground group-data-focus/option:*:data-[slot=icon]:text-white", "forced-colors:*:data-[slot=icon]:text-[CanvasText] forced-colors:group-data-focus/option:*:data-[slot=icon]:text-[Canvas]", "*:data-[slot=avatar]:-mx-0.5 *:data-[slot=avatar]:size-6 sm:*:data-[slot=avatar]:size-5");
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const sharedClasses = t1;
  let t2;
  if ($[5] !== children || $[6] !== className) {
    t2 = t3 => {
      const {
        selectedOption
      } = t3;
      if (selectedOption) {
        return <div className={clsx(className, sharedClasses)}>{children}</div>;
      }
      return <div className={clsx("group/option grid cursor-default grid-cols-[--spacing(5)_1fr] items-baseline gap-x-2 rounded-lg py-2.5 pr-3.5 pl-2 sm:grid-cols-[--spacing(4)_1fr] sm:py-1.5 sm:pr-3 sm:pl-1.5", "text-foreground text-base/6 sm:text-sm/6 forced-colors:text-[CanvasText]", "data-focus:text-foreground outline-hidden data-focus:bg-blue-500", "forced-color-adjust-none forced-colors:data-focus:bg-[Highlight] forced-colors:data-focus:text-[HighlightText]", "data-disabled:opacity-50")}><svg className="relative hidden size-5 self-center stroke-current group-data-selected/option:inline sm:size-4" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 8.5l3 3L12 4" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg><span className={clsx(className, sharedClasses, "col-start-2")}>{children}</span></div>;
    };
    $[5] = children;
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t2) {
    t3 = <Headless.ListboxOption as={Fragment} {...props}>{t2}</Headless.ListboxOption>;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export function ListboxLabel(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = clsx(className, "ml-2.5 truncate first:ml-0 sm:ml-2 sm:first:ml-0");
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <span {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function ListboxDescription(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = clsx(className, "text-muted-foreground flex flex-1 overflow-hidden group-data-focus/option:text-white before:w-2 before:min-w-0 before:shrink dark:text-zinc-400");
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = <span className="flex-1 truncate">{children}</span>;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <span {...props} className={t1}>{t2}</span>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}